import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "wth_cookie_consent";

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  if (choice) return null;
  const set = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  return (
    <div className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:w-[420px] z-[60] bg-white border border-slate-200 rounded-2xl shadow-2xl p-5" data-testid="cookie-consent" role="dialog" aria-label="Cookie preferences">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand/10 flex items-center justify-center shrink-0"><Cookie className="w-5 h-5 text-brand" /></div>
        <div>
          <h3 className="font-heading font-bold text-slate-950">Your cookie choices</h3>
          <p className="text-sm text-slate-500 mt-1">We use essential cookies to run the site and, with your consent, analytics to improve it. See our <Link to="/cookies" className="text-brand font-semibold underline">Cookie Policy</Link>.</p>
          <div className="flex gap-2 mt-4">
            <Button onClick={() => set("accepted")} className="rounded-full bg-brand hover:bg-brand-hover flex-1" data-testid="cookie-accept">Accept all</Button>
            <Button onClick={() => set("essential")} variant="outline" className="rounded-full flex-1" data-testid="cookie-decline">Essential only</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
